import React from 'react';
import { motion } from 'framer-motion';
import { ColumviLogo } from './ColumviLogo';
import { ColumviBackground } from './ColumviBackground';
interface ColumviQuizSlideProps {
  question: string;
  context?: string;
  answers: Array<{
    id: string;
    text: string;
  }>;
  onAnswerSelect?: (answerId: string) => void;
}
export function ColumviQuizSlide({
  question,
  context,
  answers,
  onAnswerSelect
}: ColumviQuizSlideProps) {
  return <ColumviBackground data-id="element-51">
      <div className="flex flex-col h-full px-6 py-8" data-id="element-52">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6
      }} className="mb-4" data-id="element-53">
          <ColumviLogo size="sm" variant="light" data-id="element-54" />
        </motion.div>

        {/* Question Area */}
        <div className="flex flex-col justify-start mt-2 mb-4" data-id="element-55">
          <motion.h1 className="text-white text-2xl leading-tight mb-3" style={{
          fontFamily: 'var(--font-gotham)',
          fontWeight: 800
        }} initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} data-id="element-56">
            {question}
          </motion.h1>

          {context && <motion.p className="text-white/60 text-sm leading-relaxed" style={{
          fontFamily: 'var(--font-gotham)'
        }} initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} data-id="element-57">
              {context}
            </motion.p>}
        </div>

        {/* Answer Buttons */}
        <div className="space-y-3 pb-2" data-id="element-58">
          {answers.map((answer, index) => <motion.button key={answer.id} className="w-full text-center px-5 py-4 rounded-xl text-white text-lg font-semibold transition-all duration-200" style={{
          fontFamily: 'var(--font-gotham)',
          background: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.15)'
        }} initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 0.7 + index * 0.12
        }} whileHover={{
          scale: 1.02,
          background: 'rgba(255,255,255,0.15)',
          boxShadow: '0 0 20px rgba(231,111,36,0.2)'
        }} whileTap={{
          scale: 0.98
        }} onClick={() => onAnswerSelect?.(answer.id)} data-id="element-59">
              {answer.text}
            </motion.button>)}
        </div>

        {/* Image below questions */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.0,
        duration: 0.6
      }} className="mt-3 mb-2 flex justify-center" data-id="element-60">
          <img src="https://cdn.magicpatterns.com/uploads/nm43Qd7hYcqL8AuwjyJ5Za/Screenshot_2026-02-21_at_08.40.18.png" alt="Mechanism visual" className="w-[55%] mx-auto rounded-xl shadow-lg border border-white/10" data-id="element-61" />
        </motion.div>
      </div>
    </ColumviBackground>;
}